import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'duration'
})
export class DurationPipe implements PipeTransform {
    transform(value: String|moment.Moment, ...args: any[]): any {
        let [format] = args;

        let duration = moment.duration(value);

        let result = '';

        switch (format) {
            case 'seconds':
                result = String(duration.seconds());
                break;
            case 'minutes':
                result = String(duration.minutes());
                break;
            case 'hours':
                result = String(duration.hours());
                break;
            default:
                result = `${duration.hours()}h:${duration.minutes()}m:${duration.seconds()}s`;

                break;
        }

        return result;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/pipes/duration.pipe.ts